import { render, staticRenderFns } from "./ProductMedia.vue?vue&type=template&id=1b8e77b7&scoped=true&"
import script from "./ProductMedia.vue?vue&type=script&lang=js&"
export * from "./ProductMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8e77b7",
  null
  
)

export default component.exports